module.exports = __webpack_public_path__ + "assets/media/kelvin-2.3ff0da01.png";